export default {
  error: null,
  isLoading: false,
  salutations: null,
};
